import { graphql } from 'react-relay';

import { commit } from '../../mutations/commit';

const mutationForUpdateCashbackState = graphql`
  mutation updateCashbackStateMutation($input: UpdateCashbackStateInput!) {
    updateCashbackState(input: $input) {
      cashback {
        id
        date
        name
        rate
        amount
        source
        pended
        plaidTransactionId
        transactionAmount
        fastCashId
        state
        quarantinedReason
        availableStates
        userAuth0Id
        ...CashbackShow_cashback
      }
      errorMessage
      errors {
        key
        messages
      }
    }
  }
`;

const mutationForUpdateCashbackStateAndLoadFastCash = graphql`
  mutation updateCashbackStateAndLoadFastCashMutation(
    $input: UpdateCashbackStateInput!
    $byAuth0Id: String!
    $afterDate: Date!
    $beforeDate: Date!
    $bankAccountIdEq: String!
    $stateEq: String
    $storeIdEq: String
    $integrationItemIdEq: Int
    $nameCont: String
    $byMerchantNames: String
    $nameNotIContAll: String
  ) {
    updateCashbackState(input: $input) {
      cashback {
        ...CashbackCell_cashback
      }
      fastCash(byAuth0Id: $byAuth0Id) {
        ...FastCashContainer_fastCash
      }
      errorMessage
      errors {
        key
        messages
      }
    }
  }
`;

const formMutationParams = (params, args) => {
  const {
    id,
    state,
    quarantinedReason,
    afterDate,
    beforeDate,
    byAuth0Id,
    stateEq,
    bankAccountIdEq,
  } = params;
  const inputParams = { id, state, quarantinedReason };

  if (byAuth0Id) {
    return {
      mutation: mutationForUpdateCashbackStateAndLoadFastCash,
      variables: {
        input: inputParams,
        afterDate,
        beforeDate,
        bankAccountIdEq,
        stateEq,
        byAuth0Id,
      },
      ...args,
    };
  }

  return {
    mutation: mutationForUpdateCashbackState,
    variables: {
      input: inputParams,
    },
    ...args,
  };
};

const UpdateCashbackState = (environment, params, args = {}) => {
  const mutationParams = formMutationParams(params, args);

  return commit(environment, mutationParams);
};

export default UpdateCashbackState;
